import { CrudForm } from '../../containers/crud/crudForm';
import { translate } from '../../../localization';
import { Crud } from '../../containers/crud/crud';
import { formatDate } from '@arivaa-react/helpers/date-util';
import { Switch } from 'antd';
import { WebCrud } from '../../containers/crud/webCrud';
export default function Service() {
  return (
    <WebCrud
      api="service"
      FormComponent={(props) => (
        <CrudForm
          {...props}
          elements={[
            {
              type: 'text',
              name: 'title',
              label: translate('common.title'),
              required: true,
              inputProps: {
                maxLength: 200,
              },
            },
            {
              type: 'text',
              name: 'subTitle',
              label: translate('service.subTitle'),
              required: true,
              inputProps: {
                maxLength: 200,
              },
            },
            {
              type: 'file',
              name: 'image',
              label: translate('service.image'),
              required: false,
              fileCode: 'mediaFile',
            },
            {
              type: 'text',
              name: 'description',
              label: translate('service.description'),
              required: true,
              inputProps: {
                maxLength: 500,
              },
            },
            {
              type: 'select',
              name: 'type',
              label: translate('service.type'),
              required: true,
              data: [
                {
                  label: 'Services',
                  value: 'Services',
                },
                {
                  label: 'Home',
                  value: 'Home',
                },
              ],
            },
            {
              type: 'switch',
              name: 'published',
              label: translate('service.published'),
              required: false,
            },
          ]}
        />
      )}
    >
      <Crud.Header title="Services">
        <Crud.Header.Actions.Common />
      </Crud.Header>
      <Crud.Table
        actions={[
          ...Crud.Table.RowActions.Common,
          () => (
            <Crud.Table.RowActions.DuplicateRecordWithForm
              elements={[
                {
                  type: 'text',
                  label: 'Enter new title',
                  name: 'title',
                  inputProps: {
                    placeholder: 'title',
                  },
                },
              ]}
            />
          ),
        ]}
        columns={[
          {
            title: translate('service.title'),
            dataIndex: 'title',
          },
          {
            title: translate('service.subTitle'),
            dataIndex: 'subTitle',
          },
          {
            title: translate('service.type'),
            dataIndex: 'type',
          },
          {
            title: translate('service.published'),
            dataIndex: 'published',
            render: (text) => {
              return text ? 'Yes' : 'No';
            },
          },
          {
            title: translate('service.publishedAt'),
            dataIndex: 'createdAt',
            render: (text) => {
              return formatDate(text);
            },
          },
        ]}
      >
        <Crud.Table.Header>
          <Crud.Search
            fields={[
              {
                name: 'title',
                type: 'text',
                inputProps: {
                  placeholder: translate('common.title'),
                },
              },
              {
                inputProps: {
                  placeholder: translate('service.published'),
                },
                label: translate('service.published'),
                name: 'published',
                type: 'custom',
                Component: Switch,
              },
            ]}
          ></Crud.Search>
          <Crud.Table.BulkRowActions.Common />
        </Crud.Table.Header>
        <Crud.Table.TableActions.Common />
      </Crud.Table>
    </WebCrud>
  );
}
